import { styled } from "@mui/material";
export const ContainerStatistics = styled("div")(({ theme }) => ({
    display: "grid",
    gap: "20px",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    },
  }));
  